// components/routeGuards/PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useLoginContext } from "../../Contexts/LoginContext";
import LoadingScreen from "../reusable/loadingScreen";

export default function PrivateRoute({ children }) {
  const { loggedIn, loading } = useLoginContext();

  if (loading) return <LoadingScreen />;

  return loggedIn ? children : <Navigate to="/login" replace />;
}
